import * as React from 'react';
const SvgCloseIcon = (props) => (
  <svg
    width={13}
    height={13}
    style={{ width: 13, height: 13 }}
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.49251 0.120332C3.97295 -0.415211 4.64812 2.85724 6.64754 3.67746C8.15435 2.56974 10.1654 -1.53703 12.4517 0.613595C14.2453 2.29915 11.1796 5.15444 9.82343 6.25653C6.88515 8.6411 5.89993 8.56218 3.0196 6.12687C1.64319 4.96277 -2.0485 0.881367 1.49251 0.120332Z"
      fill="#5A5A87"
    />
    <path
      d="M11.5075 12.8797C9.02705 13.4152 8.35188 10.1428 6.35246 9.32254C4.84565 10.4303 2.83463 14.537 0.548339 12.3864C-1.24534 10.7009 1.82044 7.84556 3.17657 6.74347C6.11485 4.3589 7.10007 4.43782 9.9804 6.87313C11.3568 8.03723 15.0485 12.1186 11.5075 12.8797Z"
      fill="#5A5A87"
    />
  </svg>
);
export default SvgCloseIcon;
